import { render, staticRenderFns } from "./SfrLogoSvg.vue?vue&type=template&id=66892abd&"
import script from "./SfrLogoSvg.vue?vue&type=script&lang=js&"
export * from "./SfrLogoSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports